import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchCards } from "../api";
import IMAGES from "../data/imageMap";
import { useSiteContent } from "../contexts/SiteContent";

export default function Domains() {
  const { t } = useSiteContent();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    fetchCards("domains").then(setCards).catch(() => setCards([]));
  }, []);

  return (
    <section
      id="domains"
      data-testid="domains-section"
      className="bg-white py-16 md:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-[720px]">
          <h2 className="text-[32px] md:text-[44px] font-semibold tracking-[-0.02em] leading-[1.1] text-neutral-900">
            {t("domains_intro.heading", "Domains")}
          </h2>
          <p className="mt-4 text-[16px] md:text-[17px] text-neutral-600 leading-relaxed">
            {t(
              "domains_intro.subtitle",
              "We take a multidisciplinary approach to connect different fields of scientific study, supporting researchers as they work toward new breakthroughs."
            )}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {cards.map((card) => {
            const to = card.slug ? `/domains/${card.slug}` : null;
            const Cmp = to ? Link : "div";
            const cmpProps = to ? { to } : {};
            return (
              <Cmp
                key={card.id}
                {...cmpProps}
                data-testid={`domain-card-${card.slug}`}
                className={`group relative overflow-hidden rounded-2xl bg-[#0b0b0c] min-h-[240px] md:min-h-[260px] block transition-all duration-200 ${
                  to ? "cursor-pointer hover:-translate-y-1 hover:shadow-[0_18px_48px_rgba(0,0,0,0.25)]" : ""
                }`}
              >
                <div className="absolute inset-0">
                  <img
                    src={IMAGES.domains[card.order]}
                    alt=""
                    loading="lazy"
                    className="w-full h-full object-cover opacity-70 transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0c] via-[#0b0b0c]/85 to-transparent" />
                </div>

                <div className="relative p-7 md:p-8 flex flex-col justify-end h-full min-h-[240px] md:min-h-[260px] max-w-[58%]">
                  <h3 className="text-white text-[22px] md:text-[24px] font-semibold tracking-tight leading-snug">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-[#c7c7c8] text-[14px] leading-relaxed">
                    {card.blurb}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-white text-[14px] font-medium">
                    Learn more
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Cmp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
